export const defaultSettings = {
  water: {
    unit: "لیتر",
    factor: 1,
    float: 0,
  },
  power: {
    unit: "وات ساعت",
    factor: 1,
    float: 0,
  },
  gas: {
    unit: "مترمکعب",
    factor: 1,
    float: 0,
  },
};

export const getProjectUnits = (projectInfo) => {
  if (!projectInfo) {
    return defaultSettings;
  }
  const settings = projectInfo.settings;
  if (!settings) {
    return defaultSettings;
  }
  const consumptionValuesSettings = settings.consumptionValues;
  //   console.log("consumption values: ", consumptionValuesSettings);
  if (!consumptionValuesSettings) {
    return defaultSettings;
  }
  const defaultWater = defaultSettings.water;
  const defaultPower = defaultSettings.power;
  const defaultGas = defaultSettings.gas;
  const waterSettings = consumptionValuesSettings.water;
  const powerSettings = consumptionValuesSettings.power;
  const gasSettings = consumptionValuesSettings.gas;

  //   console.log("water settings: ", waterSettings);

  const results = {
    water: waterSettings ? waterSettings : defaultWater,
    power: powerSettings ? powerSettings : defaultPower,
    gas: gasSettings ? gasSettings : defaultGas,
  };

  return results;
};
